import { render } from "./Navbar-Lateral.vue?vue&type=template&id=31ca4b3b&scoped=true"
import script from "./Navbar-Lateral.vue?vue&type=script&lang=js"
export * from "./Navbar-Lateral.vue?vue&type=script&lang=js"

import "./Navbar-Lateral.vue?vue&type=style&index=0&id=31ca4b3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ca4b3b"]])

export default __exports__